import { Paper } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { baseUrl } from "../../../../services/config";

const ExamEntryReport = () => {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);

  const [sessionData, setSessionData] = useState([]);
  const [yearId, setYearId] = useState("");
  const [campusData] = useState(user?.campuses || []);
  const [campusId, setCampusId] = useState("");
  const [exams, setExams] = useState([]);
  const [examId, setExamId] = useState("");
  const [examsLoading, setExamsLoading] = useState(false);

  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState("");
  const [sections, setSections] = useState([]);
  const [sectionId, setSectionId] = useState("");
  const [sectionsLoading, setSectionsLoading] = useState(false);

  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);

  useEffect(() => {
    getSettingData();
    getSessions();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch(console.log);
  };

  const getSessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((s) => {
          if (s.active_academic_year == "1") {
            setYearId(s.id);
          }
        });
      })
      .catch(console.log);
  };

  const resetBelowExam = () => {
    setClasses([]);
    setClassId("");
    setSections([]);
    setSectionId("");
    setIsVisible(false);
    setReportData(null);
  };

  const loadExams = (sessionId, campus) => {
    if (!sessionId || !campus) return;
    setExams([]);
    setExamId("");
    resetBelowExam();
    setExamsLoading(true);
    fetch(`${baseUrl}/exam_for_session`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify({ year_id: sessionId, campus_id: campus }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExamsLoading(false);
        const payload = data.payload;
        const list = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.exams)
          ? payload.exams
          : [];
        setExams(list);
      })
      .catch(() => setExamsLoading(false));
  };

  const handleSessionChange = (e) => {
    const val = e.target.value;
    setYearId(val);
    loadExams(val, campusId);
  };

  const handleCampusChange = (e) => {
    const val = e.target.value;
    setCampusId(val);
    loadExams(yearId, val);
  };

  const handleExamChange = (e) => {
    const val = e.target.value;
    setExamId(val);
    setClassId("");
    setSections([]);
    setSectionId("");
    setIsVisible(false);
    setReportData(null);
    if (!val) { setClasses([]); return; }
    const selected = exams.find((ex) => ex.id == val);
    setClasses(selected?.student_classes || []);
  };

  const handleClassChange = (e) => {
    const val = e.target.value;
    setClassId(val);
    setSectionId("");
    setSections([]);
    setIsVisible(false);
    setReportData(null);
    if (!val || !campusId) return;
    setSectionsLoading(true);
    fetch(`${baseUrl}/class_section/${campusId}/1/${val}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setSectionsLoading(false);
        setSections(data.payload || []);
      })
      .catch(() => setSectionsLoading(false));
  };

  const handleGetData = () => {
    if (!yearId) { alert.error("Please select a session"); return; }
    if (!campusId) { alert.error("Please select a campus"); return; }
    if (!examId) { alert.error("Please select an exam"); return; }

    setLoading(true);
    setIsVisible(false);
    setReportData(null);

    fetch(`${baseUrl}/exam-progress-report`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify({
        session_id: yearId,
        campus_id: campusId,
        exam_id: examId,
        ...(classId && { student_class_id: classId }),
        ...(sectionId && { global_section_id: sectionId }),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setIsVisible(true);
        setReportData(data.payload || null);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const percentColor = (pct) => {
    if (pct >= 80) return "#1BC5BD";
    if (pct >= 50) return "#FFA800";
    return "#F64E60";
  };

  const ProgressBar = ({ pct }) => (
    <div style={{ width: "100%", background: "#EEF0F8", borderRadius: 4, height: 8, marginTop: 4 }}>
      <div style={{ width: `${Math.min(pct, 100)}%`, background: percentColor(pct), borderRadius: 4, height: 8 }} />
    </div>
  );

  const summary = reportData?.summary;
  const reportClasses = reportData?.classes || [];
  const exam = reportData?.exam;

  const selectedCampusName = campusData.find((c) => c.id == campusId)?.name || "";
  const selectedSession = sessionData.find((s) => s.id == yearId)?.year || "";
  const selectedClassName = classes.find((c) => c.id == classId)?.name || "";
  const selectedSectionName = sections.find((s) => s.id == sectionId)?.name || "";

  // Defined outside JSX so react-to-print can read a stable DOM node
  // from the always-mounted hidden div — same pattern as ChallanReceiveUserWise,
  // DemandPaySheet, and all other working reports in this codebase.
  const ReportContent = () => (
    <div id="tableboot">
      <div className="p-3" style={{ display: "flex", alignItems: "center", gap: 15 }}>
        <img style={{ height: 80, width: 80 }} src={icon} alt="logo" />
        <div>
          <h2 style={{ margin: 0 }}>{unitName}</h2>
          <h5 style={{ color: "#7E8299", margin: 0 }}>Exam Entry Progress Report</h5>
        </div>
      </div>

      <div className="px-3 pb-2" style={{ fontSize: 13 }}>
        <b>Session:</b> {selectedSession}&nbsp;&nbsp;
        <b>Campus:</b> {selectedCampusName}&nbsp;&nbsp;
        {exam && <><b>Exam:</b> {exam.name}&nbsp;&nbsp;</>}
        {selectedClassName && <><b>Class:</b> {selectedClassName}&nbsp;&nbsp;</>}
        {selectedSectionName && <><b>Section:</b> {selectedSectionName}&nbsp;&nbsp;</>}
      </div>

      {summary && (
        <div style={{ display: "flex", gap: 12, padding: "0 12px 16px" }}>
          {[
            { label: "Total Entries", value: summary.total, color: "#3699FF" },
            { label: "Done", value: summary.done, color: "#1BC5BD" },
            { label: "Remaining", value: summary.remaining, color: "#F64E60" },
            { label: "Progress", value: `${summary.percent}%`, color: percentColor(summary.percent) },
          ].map((card) => (
            <div
              key={card.label}
              style={{
                flex: "1 1 0",
                padding: "12px 16px",
                borderRadius: 8,
                borderLeft: `5px solid ${card.color}`,
                background: "#F8F9FA",
              }}
            >
              <div style={{ color: "#7E8299", fontSize: 12, marginBottom: 4 }}>{card.label}</div>
              <div style={{ color: card.color, fontSize: 22, fontWeight: 700 }}>{card.value}</div>
              {card.label === "Progress" && <ProgressBar pct={summary.percent} />}
            </div>
          ))}
        </div>
      )}

      <Table bordered style={{ fontSize: 13 }}>
        <thead>
          <tr style={{ background: "#F3F6F9" }}>
            <th>Class / Section / Subject</th>
            <th style={{ textAlign: "center" }}>Total</th>
            <th style={{ textAlign: "center" }}>Done</th>
            <th style={{ textAlign: "center" }}>Remaining</th>
            <th style={{ minWidth: 140 }}>Progress</th>
          </tr>
        </thead>
        <tbody>
          {reportClasses.length > 0 ? (
            reportClasses.map((cls) => (
              <React.Fragment key={cls.class_id}>
                <tr style={{ background: "#EEF0F8", fontWeight: 600 }}>
                  <td style={{ color: "#181C32", paddingLeft: 8, fontSize: 16 }}>{cls.class_name}</td>
                  <td style={{ textAlign: "center", color: "#181C32" }}>{cls.total}</td>
                  <td style={{ textAlign: "center", color: "#1BC5BD" }}>{cls.done}</td>
                  <td style={{ textAlign: "center", color: "#F64E60" }}>{cls.remaining}</td>
                  <td>
                    <div style={{ fontSize: 12, color: percentColor(cls.percent) }}>{cls.percent}%</div>
                    <ProgressBar pct={cls.percent} />
                  </td>
                </tr>
                {(cls.sections || []).map((sec) => (
                  <React.Fragment key={sec.section_id}>
                    <tr style={{ background: "#FAFAFA" }}>
                      <td style={{ color: "#3F4254", paddingLeft: 24, fontWeight: 700 }}>&nbsp;Section {sec.section_name}</td>
                      <td style={{ textAlign: "center", color: "#3F4254" }}>{sec.total}</td>
                      <td style={{ textAlign: "center", color: "#1BC5BD" }}>{sec.done}</td>
                      <td style={{ textAlign: "center", color: "#F64E60" }}>{sec.remaining}</td>
                      <td>
                        <div style={{ fontSize: 12, color: percentColor(sec.percent) }}>{sec.percent}%</div>
                        <ProgressBar pct={sec.percent} />
                      </td>
                    </tr>
                    {(sec.subjects || []).map((sub) => (
                      <tr key={sub.subject_id}>
                        <td style={{ color: "#7E8299", paddingLeft: 48 }}>&nbsp;&nbsp;{sub.subject_name}</td>
                        <td style={{ textAlign: "center", color: "#7E8299" }}>{sub.total}</td>
                        <td style={{ textAlign: "center", color: "#1BC5BD" }}>{sub.done}</td>
                        <td style={{ textAlign: "center", color: "#F64E60" }}>{sub.remaining}</td>
                        <td>
                          <div style={{ fontSize: 12, color: percentColor(sub.percent) }}>{sub.percent}%</div>
                          <ProgressBar pct={sub.percent} />
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td colSpan={5} style={{ textAlign: "center" }}>No data found</td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );

  return (
    <Paper style={{ marginTop: 10, marginBottom: 10, padding: 15 }}>
      {/* row 1 — required filters */}
      <div className="row">
        <div className="col-md-3">
          <label><b>Select Session</b> <span style={{ color: "red", fontSize: 12 }}>*</span></label>
          <select style={{ height: 40 }} className="form-select" value={yearId} onChange={handleSessionChange}>
            <option value="">Select Session</option>
            {sessionData.map((s) => (
              <option key={s.id} value={s.id}>{s.year}</option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label><b>Select Campus</b> <span style={{ color: "red", fontSize: 12 }}>*</span></label>
          <select style={{ height: 40 }} className="form-select" value={campusId} onChange={handleCampusChange}>
            <option value="">Select Campus</option>
            {campusData.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label>
            <b>Select Exam</b> <span style={{ color: "red", fontSize: 12 }}>*</span>
            {examsLoading && <Spinner animation="border" size="sm" variant="info" className="ml-2" />}
          </label>
          <select
            style={{ height: 40 }}
            className="form-select"
            value={examId}
            onChange={handleExamChange}
            disabled={exams.length === 0}
          >
            <option value="">{exams.length === 0 ? "Select Session & Campus first" : "Select Exam"}</option>
            {exams.map((ex) => (
              <option key={ex.id} value={ex.id}>{String(ex.exam_name ?? "")}</option>
            ))}
          </select>
        </div>
      </div>

      {/* row 2 — optional filters + buttons */}
      <div className="row mt-3">
        <div className="col-md-3">
          <label><b>Select Class</b> <span style={{ color: "#999", fontSize: 12 }}>(optional)</span></label>
          <select
            style={{ height: 40 }}
            className="form-select"
            value={classId}
            onChange={handleClassChange}
            disabled={classes.length === 0}
          >
            <option value="">{classes.length === 0 ? "Select Exam first" : "All Classes"}</option>
            {classes.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label>
            <b>Select Section</b> <span style={{ color: "#999", fontSize: 12 }}>(optional)</span>
            {sectionsLoading && <Spinner animation="border" size="sm" variant="info" className="ml-2" />}
          </label>
          <select
            style={{ height: 40 }}
            className="form-select"
            value={sectionId}
            onChange={(e) => setSectionId(e.target.value)}
            disabled={sections.length === 0}
          >
            <option value="">{sections.length === 0 ? "Select Class first" : "All Sections"}</option>
            {sections.map((s) => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>

        <div className="col-md-3 mt-9 d-flex align-items-start">
          <button className="btn btn-primary mr-4" style={{ height: 40 }} onClick={handleGetData}>
            Show
          </button>
          {isVisible && reportData && (
            <ReactToPrint
              documentTitle="Exam Entry Progress Report"
              pageStyle="auto"
              onAfterPrint={handleAfterPrint}
              onBeforeGetContent={handleOnBeforeGetContent}
              onBeforePrint={handleBeforePrint}
              removeAfterPrint={true}
              trigger={() => (
                <button
                  disabled={printloading ? true : false}
                  className="btn btn-primary mx-2"
                  style={{ height: 40 }}
                >
                  {printloading ? <span>Printing..</span> : "Print"}
                </button>
              )}
              content={() => componentRef.current}
            />
          )}
        </div>
      </div>

      {/* on-screen result */}
      <div className="mt-5">
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Spinner class="text-center" variant="info" animation="border" />
          </div>
        ) : (
          isVisible && reportData && <ReportContent />
        )}
      </div>

      {/* always-mounted hidden div — react-to-print clones this node.
          visibility:hidden keeps it out of layout without unmounting it.
          Same pattern as ChallanReceiveUserWise, DemandPaySheet, etc. */}
      <div
        ref={componentRef}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <ReportContent />
      </div>
    </Paper>
  );
};

export default ExamEntryReport;
